import React, {useCallback, useEffect, useState} from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import {Link, Image} from '@shopify/hydrogen';
import noImage from '../../assets/image/default-book-image-not-found.png';
import '../../assets/css/carousel.css';

export default function ProductCarouselProd({sanityData}){
  /**
   * @const viewportRef, embla - Embla Carousel instance and viewport reference.
   */
  const [viewportRef, embla] = useEmblaCarousel({
    containScroll: 'scrollSnap',
    slidesToScroll: 1,
    inViewThreshold: 1,
    skipSnaps: false,
    selectedClass: '',
    dragFree: true,
    align: 'start',
    loop: false,
  });

  const [product, setProduct] = useState(null);

  useEffect(()=>{
    fetch(`https://search.ellibrero.com/carrousel?id=`+sanityData.store.id,
      {
        method: 'GET',
        headers: {},
      }
    )
    .then((response) => response.json())
    .then((data) => {
      let finalData = [];

      for(let info of data.result){
        finalData.push(info);
      }

      setProduct(finalData);
    })
    .catch((error) => {
      // console.error('Error:', error);
    });
  },[])

  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);
  const [refreshCarrousel, setRefreshCarrousel] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);

  const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla]);
  const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla]);

  const onSelect = useCallback(() => {
    if (!embla) return;
    setSelectedIndex(embla.selectedScrollSnap());
    setPrevBtnEnabled(embla.canScrollPrev());
    setNextBtnEnabled(embla.canScrollNext());
  }, [embla, setSelectedIndex]);

  useEffect(() => {
    if (!embla) return;
    onSelect();
    setScrollSnaps(embla.scrollSnapList());
    embla.on('select', onSelect);
  }, [embla, setScrollSnaps, onSelect]);


  const defineDecimal = (price)=>{
    if(price.indexOf('.') < 0){
      return price+'.00';
    }
    return price;
  };

  return (
    <section
      className={`section_librero products_carousel carousel-related`}
    >
      <div className="librero_carousel container md:mx-auto">
        <h2 className="section-title">
          Otros títulos que también te podrían gustar
        </h2>
        <div className="embla relative">
          {!refreshCarrousel && product && (
              <div className="product_carousel_wrapper px-12 mx-auto relative xs:px-0">
                <PrevButton onClick={scrollPrev} enabled={prevBtnEnabled} />
                <NextButton onClick={scrollNext} enabled={nextBtnEnabled} />
                <div className="carousel_inner overflow-hidden">
                  <div ref={viewportRef}>
                    <div className="embla__container">
                      {product
                        ? product.map((item) => {
                              return (
                                <>
                                  <div
                                    className="md:embla__slide--thumb product_slide xs:w-full relative slide-carroucel"
                                    style={{height: 'auto'}}
                                    key={item?._key ? item._key : 'prod-' + item.id}
                                  >
                                    <Link
                                      className="card_link carousel-card"
                                      to={'/producto/'+item.slug}
                                      reloadDocument="true"
                                    >
                                      <div className="product__card card rounded-xl border-white bg-white">
                                        <div className="justify-center items-center flex">
                                          <div className="product__card_image_wrapper relative w-full flex items-center">
                                            <Image
                                              src={item?.image ? item.image : noImage}
                                              height={185}
                                              width={159}
                                              className="product__card_image"
                                              alt="Search"
                                              />
                                          </div>
                                        </div>
                                        <div
                                          style={{height: '90px'}}
                                          className="bg-[#EDF0F3] p-3 justify-between flex-col flex rounded-br-xl rounded-bl-xl"
                                        >
                                          <div className="title">
                                            <h3 className="leading-tight line-clamp">
                                              {item.title}
                                            </h3>
                                          </div>
                                          <div className="autor">
                                            <p class="text-xs">
                                              Autor: &nbsp;
                                              <span className='name-autor'>
                                                      {item?.author && item.author.length > 10
                                                        ? item.author.slice(0, 10) + ' ...'
                                                        : item.author}
                                              </span>
                                            </p>
                                          </div>
                                          <div className={`card_price_wrapper flex content-end items-end gap-1 price ${(item.compare_price !== "0") ? 'small-price': ''}`}>
                                            <span 
                                              className={`card_price text-red-40 font-bold`}                                              
                                            >
                                            MXN&nbsp;{defineDecimal(item.price)}
                                            </span>
                                            {item.compare_price !== "0" && (
                                              <span className="sale-price mb-0 text-xs leading-none text-purple-40 line-through">
                                                MXN&nbsp;{defineDecimal(item.compare_price)}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </Link>
                                  </div>
                                </>
                              );
                          })
                        : ''}
                    </div>
                  </div>
                </div>
              </div>
          )}
        </div>
      </div>
    </section>
  );
}

const PrevButton = ({enabled, onClick}) => (
  <button
    className={` ${
      !enabled ? 'disabled' : 'fill-purple-120'
    } btn-prev xs:hidden left-0 absolute bottom-46 flex items-center justify-center rounded-full h-10 w-10 bg-white cursor-pointer`}
    onClick={onClick}
    disabled={!enabled}
  >
    <svg
      className={` ${!enabled ? 'fill-white' : 'fill-purple-120'}
          embla__button__svg h-5 w-5  fill-purple-120
        `}
      viewBox="137.718 -1.001 366.563 644"
    >
      <path d="M428.36 12.5c16.67-16.67 43.76-16.67 60.42 0 16.67 16.67 16.67 43.76 0 60.42L241.7 320c148.25 148.24 230.61 230.6 247.08 247.08 16.67 16.66 16.67 43.75 0 60.42-16.67 16.66-43.76 16.67-60.42 0-27.72-27.71-249.45-249.37-277.16-277.08a42.308 42.308 0 0 1-12.48-30.34c0-11.1 4.1-22.05 12.48-30.42C206.63 234.23 400.64 40.21 428.36 12.5z" />
    </svg>
  </button>
);

const NextButton = ({enabled, onClick}) => {
  return (
    <button
      className={` ${
        !enabled ? 'disabled' : 'fill-purple-120'
      } btn-next xs:hidden absolute right-0 bottom-46 flex items-center justify-center rounded-full h-10 w-10 bg-white cursor-pointer`}
      onClick={onClick}
      disabled={!enabled}
    >
      <svg
        className={`embla__button__svg  h-5 w-5 fill-purple-120  ${
          !enabled ? 'fill-white' : 'fill-purple-120'
        }`}
        viewBox="0 0 238.003 238.003"
      >
        <path d="M181.776 107.719L78.705 4.648c-6.198-6.198-16.273-6.198-22.47 0s-6.198 16.273 0 22.47l91.883 91.883-91.883 91.883c-6.198 6.198-6.198 16.273 0 22.47s16.273 6.198 22.47 0l103.071-103.039a15.741 15.741 0 0 0 4.64-11.283c0-4.13-1.526-8.199-4.64-11.313z" />
      </svg>
    </button>
  );
};